import { useCallback, useEffect, useState } from "react";
import {
  getDashboardRefreshAvailableAt,
  getLatestLastManuallyRefreshedAt,
} from "./InsightsDetailsPage.helpers";

export const useDashboardRefreshCooldown = ({
  insightsId,
  serverLastManuallyRefreshedAt,
}: {
  insightsId: string;
  serverLastManuallyRefreshedAt: string | null | undefined;
}) => {
  const [localLastManuallyRefreshedAt, setLocalLastManuallyRefreshedAt] =
    useState<string | null>(null);
  const [nowMilliseconds, setNowMilliseconds] = useState(() => Date.now());

  useEffect(() => {
    setLocalLastManuallyRefreshedAt(null);
  }, [insightsId]);

  const lastManuallyRefreshedAt = getLatestLastManuallyRefreshedAt(
    serverLastManuallyRefreshedAt,
    localLastManuallyRefreshedAt
  );
  const refreshAvailableAt = getDashboardRefreshAvailableAt(
    lastManuallyRefreshedAt,
    nowMilliseconds
  );
  const refreshAvailableAtMilliseconds = refreshAvailableAt?.getTime();

  useEffect(() => {
    if (refreshAvailableAtMilliseconds === undefined) {
      return;
    }

    const timeoutId = setTimeout(
      () => setNowMilliseconds(Date.now()),
      Math.max(0, refreshAvailableAtMilliseconds - Date.now())
    );

    return () => clearTimeout(timeoutId);
  }, [refreshAvailableAtMilliseconds, nowMilliseconds]);

  const startCooldownFrom = useCallback((lastRefreshedAt: string) => {
    setNowMilliseconds(Date.now());
    setLocalLastManuallyRefreshedAt(lastRefreshedAt);
  }, []);

  return { lastManuallyRefreshedAt, refreshAvailableAt, startCooldownFrom };
};
